import { Typography } from '@mui/material';
import { Adress } from '../../types/dtos/VarderingarModel';

interface AdressraderProps {
  adress?: Adress;
}

export const Adressrader: React.FC<AdressraderProps> = ({ adress }) =>
  adress ? (
    <>
      <Typography variant="body1">{`${adress.gata}${
        adress.lagenhetsnummer ? ` lgh ${adress.lagenhetsnummer}` : ''
      }`}</Typography>
      <Typography variant="body1">
        {`${adress.postnummer} ${adress.postort}`}
      </Typography>
    </>
  ) : (
    <Typography variant="body1">Ingen adress vald</Typography>
  );
